import { asSingleStyleConfig } from '../../../../utils/theme';
import { headingSizes } from '../foundations/typography';
var baseStyle = {
  fontFamily: 'heading',
  letterSpacing: '-0.2px'
};
var defaultProps = {
  size: 'lg'
};
export var Heading = asSingleStyleConfig({
  baseStyle,
  sizes: headingSizes,
  defaultProps
});